import { Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../../locales";

const langRecharge = langPage?.amount;
const lang = langPage?.amount?.recharge;

export const DEFAULT_QUERY_DATA = {
    Email: "",
    MemberId: null,
    Status: null,
    AuditAtEnd: null,
    AuditAtStart: null,
    AuditAt: null,
    CreatedAtStart: null,
    CreatedAtEnd: null,
    CreatedAt: null,
    MemberAddress: null,
    NetworkId: null,
    TxId: null,
}

export const generateQueryFormConfig = (props: any): FormConfigType => {
    const { networkTypeOptions }  = props;
    return [
        {
            title: langRecharge?.email,
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: langRecharge?.memberId,
            type: "input",
            field: "MemberId",
            allowClear: true,
        },
        // {
        //     title: langRecharge?.auditAt,
        //     type: "rangePicker",
        //     field: "AuditAt",
        //     fields: ['AuditAtStart', 'AuditAtEnd'],
        //     allowClear: true,
        // },
        {
            title: langTableColumns?.CreatedAtString,
            type: "rangePicker",
            field: "CreatedAt",
            fields: ['CreatedAtStart', 'CreatedAtEnd'],
            allowClear: true,
        },
        {
            title: lang?.rechargeStatus,
            type: "select",
            field: "Status",
            options: [
                { id: 10, name: lang?.rechargeStatus2 },
                { id: 20, name: lang?.rechargeStatus3 },
                { id: 40, name: lang?.rechargeStatus5 },
            ],
            allowClear: true,
            style: {
                width: 200
            }
        },
        {
            title: "转出地址",
            type: "input",
            field: "MemberAddress",
            allowClear: true,
        },
        {
            title: "网络",
            type: "select",
            field: "NetworkId",
            options: networkTypeOptions,
            allowClear: true,
            style: {
                width: 200
            }
        },
        {
            title: "哈希值",
            type: "input",
            field: "TxId",
            allowClear: true,
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef } = props;

    return [
        {
            title: '序号',
            dataIndex: "Index",
            render(value, record, index) {
                return index + 1
            },
        },
        {
            title: '订单号',
            dataIndex: "OrderSn",
        },
        {
            title: langRecharge?.memberId,
            dataIndex: "MemberId",
        },
        {
            title: langRecharge?.email,
            dataIndex: "Email",
        },
        {
            title: '转账金额',
            dataIndex: "Amount",
        },
        {
            title: langRecharge?.commissionFee,
            dataIndex: "CommissionFee",
        },
        {
            title: langRecharge?.receivedAmount,
            dataIndex: "ReceivedAmount",
        },
        {
            title: "网络",
            dataIndex: "Network",
        },
        {
            title: "转出地址",
            dataIndex: "MemberAddress",
        },
        {
            title: lang?.rechargeUsdtAddress,
            dataIndex: "RechargeAddress",
        },
        {
            title: lang?.rechargeStatus,
            dataIndex: "StatusString",
        },
        {
            title: "hash",
            dataIndex: "TxId",
        },
        {
            title: "更新时间",
            dataIndex: "UpdatedAtString",
        },
    ]
}

export const generateOperationFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: langRecharge?.CheckResult,
            type: "select",
            field: "CheckResult",
            options: [
                { id: 40, name: langRecharge?.CheckResult1 },
                { id: 20, name: langRecharge?.CheckResult2 }
            ],
            rules: [{
                required: true,
                message: `${langCommon?.pleaseSelect} ${langRecharge?.CheckResult}`
            }]
        },
        {
            title: langRecharge?.remark,
            type: "input",
            extendType: "TextArea",
            field: "Remark",
            allowClear: true,
            rows: 5,
        },
    ];
}